import { render } from "./ClockDrawing.vue?vue&type=template&id=75b0f4af&scoped=true"
import script from "./ClockDrawing.vue?vue&type=script&lang=js"
export * from "./ClockDrawing.vue?vue&type=script&lang=js"

import "./ClockDrawing.vue?vue&type=style&index=0&id=75b0f4af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b0f4af"]])

export default __exports__